export default __webpack_public_path__ + "static/media/arrow-down.e6d0f19a.svg";